export const isImportOfRCMTransactionType = (transactionType) =>
    typeof transactionType === "string" &&
    transactionType.length === 20 &&
    transactionType.charAt(8) === "1";
